import Flickity from 'flickity';

const TextImageSlider = () => {

    const sliders = document.querySelectorAll('.text-image__images--slider');

    Array.from(sliders).forEach(slider => {

        if (typeof slider != "undefined" && slider != null) {

            var carouselStatus = slider.querySelector('.text-image__count');
            
            var flkty = new Flickity( slider, {
                adaptiveHeight: false,
                autoPlay: false,
                cellSelector: '.text-image__image',
                lazyLoad: false,
                pageDots: false,
                wrapAround: false,
                draggable: false
            });

            function updateStatus() {
                var slideNumber = flkty.selectedIndex + 1;
                if (typeof carouselStatus != "undefined" && carouselStatus != null) {
                    carouselStatus.textContent = slideNumber + ' / ' + flkty.slides.length;
                }
            }
            updateStatus();

            flkty.on( 'select', updateStatus );
        }
        
    });
}

export default TextImageSlider;